<template>
  <div>
    <QueryFrame
      :addText="handlePermission('promotionNew')?'新建活动':''"
      :customedText="handlePermission('promotionBatch')?'批量新建活动':''"
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      @addNew='addNew'
      @handleCustomed="handleCustomed"
      ref="queryFrame"
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>商品编码:</label>
            <lk-input :maxlength="100" placeholder="请输入商品编码/通用名" class="item" clearable
              v-model.trim="query.goodsCode"></lk-input>
          </div>
          <div class="queryItem">
            <label>活动名称:</label>
            <lk-input :maxlength="100" placeholder="请输入促销名称" class="item" clearable
              v-model.trim="query.promoteName"></lk-input>
          </div>
          <div class="queryItem">
            <label>活动类型:</label>
            <lk-select class="item" clearable v-model.trim='query.promoteType'>
              <lk-option v-for="item in promotionTypes" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>门店:</label>
            <storeListSelect  :isMarket='true' class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>活动状态:</label>
            <lk-select multiple class="item" clearable v-model.trim='query.promoteStatusList'>
              <lk-option v-for="item in activeTypes" :key="item.id" :value="item.key">{{item.title}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>审批状态:</label>
            <lk-select class="item" clearable v-model.trim='query.auditStatusList' multiple>
              <lk-option v-for="item in approveTypes" :key="item.id" :value="item.key">{{item.title}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData'></lk-table>
        <AddNewModal
          v-model="showModal"
        ></AddNewModal>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import utils from '../../../libs/utils'
import QueryFrame from '@/components/frame/QueryFrame.vue';
import marketing from '@/services/marketing';
import mapState from '../../../mixins/mapState';
import queryMixins from '../../../mixins/queryMixins';
import AddNewModal from '../../../components/marketing/addNewModal.vue';

export default {
  name: 'promotionList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    AddNewModal,
  },
  data() {
    return {
      showModal: false,
      query: {},
      count: 0,
      promotionStores: [],
      activeTypes: [
        {
          title: '进行中',
          key: 2,
        },
        {
          title: '未生效',
          key: 1,
        },
        {
          title: '已失效',
          key: 3,
        },
        {
          title: '已停止',
          key: 4,
        },
      ],
      approveTypes: [
        {
          title: '审批通过',
          key: 3,
        }, {
          title: '审批拒绝',
          key: 4,
        }, {
          title: '草稿',
          key: 1,
        }, {
          title: '审批中',
          key: 2,
        },
        {
          title: '已撤回',
          key: 6,
        },
      ],
      promotionTypes: [
        {
          name: '商品促销',
          id: 1,
        },
        {
          name: '买减/买折',
          id: 2,
        },
      ],
      tableData: [],
      columns: [
        {
          title: '编号',
          fixed: 'left',
          render: (h, { index }) => h('span', index + 1),
          minWidth: 90,
        },
        { title: '活动名称', key: 'name', minWidth: 140 },
        { title: '活动范围', key: 'activityTypeName', width: 90 },
        { title: '活动门店', key: 'storeName', minWidth: 200 },
        { title: '活动类型', key: 'promoteTypeName', minWidth: 120 },
        { title: '成本类型', key: 'statisticalTypeName', minWidth: 120 },
        { title: '管理类型', key: 'managementTypeName', minWidth: 120 },
        {
          title: '有效时间',
          key: 'promoteTypeName',
          minWidth: 174,
          render: (h, { row }) => h('span', utils.formatDate(row.timeBegin)+" - " + utils.formatDate(row.timeEnd)),
        },
        { title: '审批状态', key: 'auditStatusName', minWidth: 120 },
        { title: '活动状态', key: 'promoteStatusName', minWidth: 200 },
        { title: '发起人', key: 'createUserName', minWidth: 120 },
        {
          title: '操作',
          key: 'action',
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            const detail = this.handlePermission('promotionDetail') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'promotionDetail', params: { id: params.row.id } });
                },
              },
            }, '查看') : null;
            const edit = this.handlePermission('promotionEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'promotionEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑') : null;
            const stop = this.handlePermission('promotionStop') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.stopActivie(params.row.id, 1);
                },
              },
            }, '停止') : null;
            const start = this.handlePermission('promotionStart') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.stopActivie(params.row.id, 2);
                },
              },
            }, '启用') : null;
            const back = this.handlePermission('promotionCallback') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.backActivie(params.row.id);
                },
              },
            }, '撤回') : null;
            const deleteActive = this.handlePermission('promotionDelete') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.deleteActivie(params.row.id);
                },
              },
            }, '删除活动') : null;
            if (params.row.promoteStatus === 3) {
              return h('div', [detail]);
            }
            if (params.row.auditStatus === 1) {
              return h('div', [detail, edit, deleteActive]);
            }
            if (params.row.auditStatus === 2) {
              return h('div', [detail, back]);
            }
            if (params.row.auditStatus === 3) {
              if (params.row.promoteStatus === 4) {
                return h('div', [detail, start]);
              }
              return h('div', [detail, stop]);
            }
            if (params.row.auditStatus === 4) {
              return h('div', [detail, edit]);
            }
            if (params.row.auditStatus === 6) {
              return h('div', [detail, edit, deleteActive]);
            }
          },
        },
      ],
    };
  },
  methods: {
    clear() {
      this.query = {};
    },
    getData() {
      const params = Object.assign({}, this.query);
      params.page = this.page;
      params.size = this.size;
      marketing.getPromoteList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list;
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    addNew() {
      this.showModal = true;
    },
    handleCustomed() { // 批量活动
      this.$router.push({ name: 'promotionBatch' });
    },
    backActivie(promoteId) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认撤回活动？',
        onOk: () => {
          marketing.promoteCallback({ promoteId }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('活动撤回成功');
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
          });
        },
      });
    },
    stopActivie(promoteId, type) {
      this.$Modal.confirm({
        title: '提示',
        content: type === 1 ? '确认停止活动？' : '确认启用活动？',
        onOk: () => {
          marketing.promoteStop({ promoteId, type }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success(type === 1 ? '活动停止成功' : '活动启用成功');
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
          });
        },
      });
    },
    deleteActivie(promoteId) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除活动？',
        onOk: () => {
          marketing.promoteDelete({ promoteId }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('活动删除成功');
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
          });
        },
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
  .queryContainer{
    display: flex;
    padding-bottom: 16px;
    flex-wrap: wrap;
    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
      .date-item {
        display: inline-block;
        width: 280px
      }
    }
  }

</style>
